interface PackSizeQuantity {
  quantity: number;
}

export const getTotalPackQuantity = (
  quantitiesBySize: PackSizeQuantity[],
  packMultiplier = 0,
): number => quantitiesBySize.reduce((total, { quantity }) => total + quantity * packMultiplier, 0);
